exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table > thead > tr > th[data-v-54eb48f5],\n.table > tbody > tr > th[data-v-54eb48f5],\n.table > tfoot > tr > th[data-v-54eb48f5],\n.table > thead > tr > td[data-v-54eb48f5],\n.table > tbody > tr > td[data-v-54eb48f5],\n.table > tfoot > tr > td[data-v-54eb48f5] {\n    padding: 2px 1px !important;\n    vertical-align: middle;\n}\n", ""]);

// exports
